module.exports = __webpack_public_path__ + "img/swine-company.215c63c7.png";